import { render, staticRenderFns } from "./dataDetail.vue?vue&type=template&id=a22fd398"
import script from "./dataDetail.vue?vue&type=script&lang=js"
export * from "./dataDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports